<template>
    <Head>
        <title>{{title}}</title>
        <meta name="description" :content="description">
    </Head>
    <div class="layout-container max-w-full">
        <div class="max-md:hidden">
            <TopBar/>
        </div>
        <main>
            <slot/>
        </main>
        <Footer v-if="!themeStore.minimize_ui"/>
        <div v-else class="mt-20"></div>
    </div>
    <CitySelector/>
    <MobileProfileMenu/>
    <OnlyMobile :maxSize="1024">
        <MobileMenu/>
        <MobileNav/>
        <MobileSearchPopup/>
    </OnlyMobile>
    <BaseCallback/>
    <OnlyDesktop :maxSize="1024">
        <SpeedDial/>
        <!--        <ScrollUp/>-->
    </OnlyDesktop>
    <CookieAccept/>
    <Toast/>
</template>

<script>
import {Head, router} from '@inertiajs/vue3';
import {onBeforeUnmount, onMounted} from "vue";
import TopBar from "@js/components/TopBar/TopBar.vue";
import OnlyMobile from "@js/components/DynamicComponents/OnlyMobile.vue";
import MobileNav from "@js/components/Mobile/MobileNav.vue";
import Toast from "@js/components/Toast/Toast.vue";
import Footer from "@js/components/Footer/Footer.vue";
import MobileMenu from "@js/components/Mobile/MobileMenu.vue";
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import {useMenuStore} from "@js/store/MenuStore.js";
import MobileSearchPopup from "@js/components/Search/MobileSearchPopup.vue";
import {useCartStore} from "@js/store/CartStore.js";
import SpeedDial from "@js/components/Widgets/SpeedDial.vue";
import {checkDocument, setLocalStorage, getLocalStorage} from "@js/helpers.ts";
import CookieAccept from "@js/components/Widgets/CookieAccept.vue";
import BaseCallback from "@js/components/Callbacks/BaseCallback.vue";
import MobileProfileMenu from "@js/components/Mobile/MobileProfileMenu.vue";
import {useJivoStore} from "@js/store/JivoStore.js";
import CitySelector from "@js/components/Sections/Popup/CitySelector.vue";
import {useThemeStore} from "@js/store/ThemeStore.js";

export default {
    name: "Layout",
    components: {
        CitySelector,
        MobileProfileMenu,
        BaseCallback,
        CookieAccept,
        SpeedDial,
        MobileSearchPopup,
        OnlyDesktop,
        MobileMenu,
        Head,
        Footer,
        Toast,
        MobileNav,
        OnlyMobile,
        TopBar
    },
    props: {
        title: String,
        description: String,
        menuItems: {
            required: true,
        }
    },
    mounted() {
        router.on("before", (event) => {
            this.menuStore.closeSidenav()
            this.menuStore.closeProfileSidenav()
        })

        if (checkDocument()) {
            // 1) Читаем параметр из URL
            const params = new URLSearchParams(window.location.search)
            const minimizeFromUrl = params.get('minimize_ui')

            // 2) Если в ссылке "1" — сохраняем флаг в куку (30 дней).
            if (minimizeFromUrl === '1') {
                setLocalStorage('minimize_ui', '1', 60 * 24 * 365)
            }
            // (опционально) Если "0" — очищаем куку
            if (minimizeFromUrl === '0') {
                setLocalStorage('minimize_ui', '', -1)
            }

            // 3) Перед установкой флага в сторе проверяем куку
            if (getLocalStorage('minimize_ui') === '1') {
                this.themeStore.minimize_ui = true
            }
        }
    },
    setup(props) {
        const cartStore = useCartStore()
        const menuStore = useMenuStore()
        const jivoStore = useJivoStore()
        const themeStore = useThemeStore()

        onMounted(() => {
            jivoStore.init()
            cartStore.hydrate()
        })

        onBeforeUnmount(() => {
            jivoStore.teardown()
        })

        menuStore.menuItems = props.menuItems

        return {
            menuStore,
            cartStore,
            themeStore,
        }
    }
}
</script>

<style lang="scss" scoped>
.layout-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;

    main {
        flex: 1;
    }
}
</style>
